module.exports = __webpack_public_path__ + "static/media/defaultAvatar27.b85d225b.svg";